import { ref, reactive, computed } from 'vue'
import { defineStore } from 'pinia'
import { cloneDeep } from 'lodash-es'
import { todayRange, executeOnMidnight } from '@/utils/dates'
import { usePublishedNewsStore } from '@/ContextTab/stores/newsSet/published/published'
import type { DateRange } from '@/lib/types'


export const usePublishedLocalFiltersStore = defineStore('publishedLocalFilters', () => {

  const publishedNewsStore = usePublishedNewsStore()

  let initialDates = todayRange()

  const dates = reactive(cloneDeep(initialDates))
  const hideRepublications = ref(false)

  executeOnMidnight(async () => {
    const nowRange = todayRange()

    if (
      (nowRange.start.getTime() !== initialDates.start.getTime())
      && !isDatesChanged.value
    ) {
      // date changed while filter was untouched
      initialDates = nowRange
      publishedNewsStore.setReversed(false, false)
      await resetDates()
    }
  })

  const isDatesChanged = computed(() => {
    const isStartChanged = dates.start.getTime() !== initialDates?.start.getTime()
    const isEndChanged = dates.end.getTime() !== initialDates?.end.getTime()

    return isStartChanged || isEndChanged
  })

  async function updateDates(range: DateRange) {
    Object.assign(dates, range)
    await publishedNewsStore.reload()
  }

  async function resetDates() {
    Object.assign(dates, cloneDeep(initialDates))
    await publishedNewsStore.reload()
  }

  async function toggleRepublications() {
    hideRepublications.value = !hideRepublications.value
    await publishedNewsStore.reload()
  }

  /* ---------------Фильтры поиска------------------- */

  const searchQuery = ref('')

  async function updateSearchQuery(query: string) {
    searchQuery.value = query
  }

  function getSearchParams() {
    const queryString = searchQuery.value
      .split(' ')
      .map((fragment) => `"${fragment}"`)
      .join('&')

    return {
      query: `(${queryString})`,
      sort_by_relevance: false,
      status_ids: 10,
    }
  }

  return {
    dates,
    hideRepublications,
    isDatesChanged,
    searchQuery,
    updateDates,
    resetDates,
    toggleRepublications,
    updateSearchQuery,
    getSearchParams,
  }
})
